import { useMutation } from "@tanstack/react-query"
import { ApiError, api } from "@/api/client"
import { Body } from "../../../../backend/src/routes/event/mark-all-read.types"
import { AxiosError } from "axios"
import useAuth from "@/hooks/useAuth"
import { useIntl } from "react-intl"
import { useResponseNotification } from "@/hooks/useResponseNotification"

export type MarkAllReadEventsBody = Body

export const updateMarkAllReadEventsRequest = async (token: string | undefined, body: Body) => {
    await api({ token }).post(`event/mark-all-read`, body)
}
export const useMarkAllReadEventsMutation = () => {
    const { accessToken } = useAuth()
    const intl = useIntl()
    const { handleErrorResponse } = useResponseNotification()
    return useMutation<unknown, AxiosError<ApiError>, Body>({
        mutationFn: (body) => updateMarkAllReadEventsRequest(accessToken, body),
        onError: (res) => handleErrorResponse(res, intl.formatMessage({ id: "errors.error-marking-all-read" })),
    })
}
